import { Dismissed, Employees, GuestPasses, Subdivisions } from "@/views";
export default [
    { path: "subdivisions", name: "Subdivisions", component: Subdivisions },
    { path: "employees", name: "Employees", component: Employees },
    { path: "dismissed", name: "Dismissed", component: Dismissed },
    { path: "guest-passes", name: "GuestPasses", component: GuestPasses },
];
